module.exports = "Bitte beantragen Sie Benutzername und Passwort per Mail via <code>kontakt@freeband.digital</code>.<br /><br />"


//////////////////
// WEBPACK FOOTER
// ./src/store/defaultText.json
// module id = 642
// module chunks = 1